/*
 * klaviyo-subscribe.js
 * Auto-wires any <form data-klaviyo-subscribe> to Klaviyo's CORS-enabled Client
 * Subscriptions API. The form must carry:
 *   data-company  — Klaviyo public company id (e.g. PuwnPt)
 *   data-list     — target list id (subscribing triggers any "Added to List" flow)
 *   data-source   — custom_source label (optional)
 * Optional child elements (toggled via inline style so Tailwind display utilities
 * on the same node can't override a [hidden] attribute):
 *   [data-kv-fields]   — wrapper hidden on success
 *   [data-kv-success]  — success panel shown on success
 *   [data-kv-status]   — inline status line for validation / errors
 * The email input is found via input[type="email"].
 */
(function () {
  function wire(form) {
    if (form.__kvWired) return;
    form.__kvWired = true;

    var company = form.getAttribute('data-company') || '';
    var listId  = form.getAttribute('data-list') || '';
    var source  = form.getAttribute('data-source') || 'Website';
    var statusEl  = form.querySelector('[data-kv-status]');
    var successEl = form.querySelector('[data-kv-success]');
    var fieldsEl  = form.querySelector('[data-kv-fields]');
    var btn       = form.querySelector('button[type="submit"]');
    var emailInput = form.querySelector('input[type="email"]');

    function setStatus(msg, ok) {
      if (!statusEl) return;
      statusEl.textContent = msg;
      statusEl.style.display = '';
      statusEl.style.color = ok ? '' : '#E6A57E';
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (statusEl) statusEl.style.display = 'none';
      var email = emailInput ? emailInput.value.trim() : '';
      if (!/.+@.+\..+/.test(email)) {
        setStatus('Please enter a valid email address.', false);
        if (emailInput) emailInput.focus();
        return;
      }
      if (!company || !listId) {
        console.warn('[klaviyo-subscribe] missing data-company or data-list — not sent.');
        setStatus('Something went wrong — please try again shortly.', false);
        return;
      }
      if (btn) btn.disabled = true;

      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: { list: { data: { type: 'list', id: listId } } }
        }
      };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify(payload)
      }).then(function (res) {
        if (res.status === 202 || res.ok) {
          if (successEl) {
            if (fieldsEl) fieldsEl.style.display = 'none';
            successEl.style.display = '';
            if (statusEl) statusEl.style.display = 'none';
          } else {
            setStatus(form.getAttribute('data-success') || 'You’re subscribed — thank you!', true);
          }
          try {
            if (window._learnq) window._learnq.push(['identify', { '$email': email }]);
          } catch (_) {}
        } else {
          return res.text().then(function (t) { throw new Error('Klaviyo ' + res.status + ': ' + t.slice(0, 140)); });
        }
      }).catch(function (err) {
        console.warn('[klaviyo-subscribe]', err && err.message);
        if (btn) btn.disabled = false;
        setStatus('Something went wrong — please try again in a moment.', false);
      });
    });
  }

  function init() {
    var forms = document.querySelectorAll('form[data-klaviyo-subscribe]');
    for (var i = 0; i < forms.length; i++) wire(forms[i]);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
